<template>
<div>
    <Modal
        v-model="visible"
        width="600px"
        :title="formData.id ? '编辑模板' : '新增模板'"
        :footer-hide="true"
        :mask-closable="false"
        class="my-modal top"
    >
        <Form ref="form" :model="formData" :label-width="90" class="page-form less" v-if="reload">
            <FormItem prop="name" label="模板名称" :rules="$units.formRule.required('请输入')" class="full">
                <Input v-model="formData.name" placeholder="请输入" />
            </FormItem>
            <FormItem label="适用机构" prop="orgIdList" class="full">
                <selectTree v-model="formData.orgIdList" type="4" :multiple="true" :checkChild="true" ref="selectTreeRef"></selectTree>
            </FormItem>
            <FormItem label="签约机构" prop="signOrgId" class="full">
                <Select v-model="formData.signOrgId" clearable :transfer="true" filterable>
                    <Option v-for="(item, i) in orgList" :key="i" :value="item.orgId" :label="item.orgName">
                        <span class="dian" :class="{'red':item.status == 2}"></span>
                        <span class="org-icon" v-if="item.orgType == 2">省</span>
                        {{ item.orgName }}
                    </Option>
                </Select>
            </FormItem>
        </Form>
        <div class="ivu-modal-footer">
            <Button type="text" @click="visible = false">取消</Button>
            <Button type="primary" @click="submit" :loading="loading">提交</Button>
        </div>
    </Modal>
    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal"></confirm-Modal>
</div>
    
</template>

<script>
import confirmModal from '@/components/commons/confirmModal'
import selectTree from '@/components/system/selectTree3';
export default {
    components: {
        confirmModal,
        selectTree
    },
    props: [],
    data() {
        return {
            reload: false,
            visible: false,
            loading: false,
            formData: {
                signOrgId: '',
                orgIdList: [],
                name: '',
            },
            orgList: [],//签约机构列表
            type: ''
        };
    },
    methods: {
        async open(data = {}, type) {
            this.visible = true;
            this.type = type;
            this.getOrgList();
            if(data.id) {
                await this.getDetail(data.id)
            }else{
                this.formData = {
                    signOrgId: '',
                    orgIdList: [],
                    name: '',
                }
            }
            this.reload = false;
            this.$nextTick(() => {
                this.reload = true;
                this.$nextTick(()=>{
                    this.$refs.selectTreeRef && this.$refs.selectTreeRef.openChange();
                })
            });
        },
        // 详情数据
        getDetail(id) {
            return this.$http({
                type: 'GET',
                url: '/buz/contractTemplate/read/detail',
                data: {
                    id
                }
            }).then(res => {
                this.formData = res.data;
            });
        },
        // 获取签约机构列表
        getOrgList() {
            this.$http({
                type: 'GET',
                url: '/buz/contractTemplate/signOrgList',
                data: {}
            }).then(res => {
                this.orgList = res.data;
            });
        },
        submit() {
            this.$refs.form.validate().then(isok => {
                if (!isok) {
                    return;
                }
                
                const formData = JSON.parse(JSON.stringify(this.formData));
                if (this.loading) {
                    return;
                }
                if(formData.orgIdList&&formData.orgIdList.length && !formData.signOrgId){
                    this.$notice.error('请选择签约机构');
                    return
                }

                if(formData.signOrgId&&formData.orgIdList&&!formData.orgIdList.length){
                    this.$notice.error('请选择适用机构');
                    return
                }
                this.loading = true;
                formData.type = this.type;
                this.$http({
                    type: 'POST',
                    url: formData.id ? '/buz/contractTemplate/edit' : '/buz/contractTemplate/add',
                    data: formData,
                    forced: true
                })
                    .then(res => {
                        this.loading = false;
                        if(res.httpCode==500001){
                            this.$refs.confirmModal.open({
                                title:"提示",
                                content: res.msg,
                                okText:'去认证'
                            }).then(() => {
                                window.open('https://h5.esign.cn/usercenterFront/regist')
                            });
                            return;
                        }else if(res.httpCode!=1){
                            this.$notice.error(res.msg||'接口异常')
                            return;
                        }
                        this.visible = false;
                        this.reload = false;
                        this.$notice.success('提交成功');
                        this.$emit('suceess');
                    })
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.org-icon {
    padding: 2px;
    font-size: 12px;
    line-height: 1;
    border: 1px solid #e36767;
    border-radius: 2px;
    color: #e36767;
    margin-left: 6px;
    &.org {
        border-color: #e09b60;
        color: #e09b60;
    }
    &.blue {
        border-color: #6389c9;
        color: #6389c9;
    }
    &.green {
        border-color: #6fb277;
        color: #6fb277;
    }
}
.dian {
    display: inline-block;
    width: 5px;
    height: 5px;
    background: #35bf3f;
    border-radius: 50%;
    vertical-align: middle;
    &.red {
        background-color: #e3461f;
    }
}
</style>
